<template>
    <div>
        <v-overlay :value="flagLoading" z-index="999">



            <!-- From Uiverse.io by Yaya12085 --> 
             <!-- From Uiverse.io by JkHuger --> 
            <div class="isContainer">
                <div class="cssBlock"></div>
                <div class="cssBlock"></div>
                <div class="cssBlock"></div>
                <div class="cssBlock"></div>
            </div>
        </v-overlay>
    </div>
</template>

<script>
export default {
    props: {
        flagLoading: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>

/* From Uiverse.io by JkHuger */ 
.isContainer {
  display: flex;
  align-items: center;
}

.cssBlock {
  position: relative;
  box-sizing: border-box;
  float: left;
  margin: 0 10px 10px 0;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  background: #f1ad47;
}

.cssBlock:nth-child(4n+1) {
  animation: wave_23 2s ease .0s infinite;
}

.cssBlock:nth-child(4n+2) {
  animation: wave_23 2s ease .2s infinite;
}

.cssBlock:nth-child(4n+3) {
  animation: wave_23 2s ease .4s infinite;
}

.cssBlock:nth-child(4n+4) {
  animation: wave_23 2s ease .6s infinite;
  margin-right: 0;
}

@keyframes wave_23 {
  0% {
    top: 0;
    opacity: 1;
  }

  50% {
    top: 30px;
    opacity: .2;
  }

  100% {
    top: 0;
    opacity: 1;
  }
}

.loading-text {
    position: relative;
    line-height: 1rem;
    font-weight: 500;
    color: rgba(255, 255, 255,1);
    font-size: 2.5rem;
    margin-bottom: 24px;
}

</style>